import { getMomentTz, MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { RejectedBillet } from "./models/RejectedBillet";

const moment = getMomentTz();

export const getRejectedBillets = async (
	params: { shiftId: number },
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "ShiftId", value: params.shiftId },
	];

	const resp = await apiService.callV2(
		"[M2].[GetRejectedBilletsByShift]",
		parameters,
		signal,
	);

	if (resp.ok) {
		let rows = get(resp, "data.tables[0].rows", []) as RejectedBillet[];

		rows = rows.map((row) => ({
			...row,
			Timestamp: moment.utc(row["Timestamp"]).toDate(),
			FurnaceExitTime: row.FurnaceExitTime
				? moment.utc(row["FurnaceExitTime"]).toDate()
				: null,
		}));

		return rows;
	} else {
		throw new Error(resp.message || "Error fetching rejected billets");
	}
};
